
const BASE_URL = 'https://sa-prod-server.truste.ai';

// https://sa-dev-server.truste.ai
// http://localhost:8000
// https://sa-prod-server.truste.ai

export const config = {
    BASE_URL: BASE_URL
}